import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/app/layouts/AppShell';
import { TermsGate } from '@/features/auth/TermsGate';
import { isAuthenticatedSync, isPortalSessionSync } from '@/shared/lib/auth-state';

export const Route = createFileRoute('/_app')({
  beforeLoad: ({ location }) => {
    if (!isAuthenticatedSync()) {
      throw redirect({
        to: '/login',
        /* L'indirizzo **completo**, query compresa: `/mcp/authorize?request=…` senza la query
           tornerebbe sulla pagina senza sapere cosa autorizzare. Il login lo valida
           (`safeInternalHref`) prima di usarlo. */
        search: { redirect: location.href },
      });
    }
    /*
     * Un utente-cliente qui non ci entra, e non è una cortesia: la shell interna, appena
     * montata, legge configurazione tenant, dipendente collegato, notifiche e contatori —
     * per lui tutte negate dal muro del portale. Il risultato non sarebbe un'app con
     * qualche errore ma una schermata di avvisi rossi, con il gate «nessuna anagrafica
     * collegata» che blocca prima ancora dei suoi dati.
     *
     * La guardia sta qui e non solo nel redirect dopo il login perché il login è **un**
     * ingresso: reload, link salvato e ritorno da un refresh scaduto passano di qua senza
     * toccarlo.
     */
    if (isPortalSessionSync()) {
      throw redirect({ to: '/portal', replace: true });
    }
  },
  component: AppWithGates,
});

/** Layout autenticato + wall termini (Sprint 1: blocca finché termsAccepted=false). */
function AppWithGates() {
  return (
    <>
      <TermsGate />
      <AppLayout />
    </>
  );
}
